<div [kalLoading]="loading$ | async">

    <div *ngFor="let planAndSections of analyticalPlans">

        <label>{{planAndSections.plan.Libelle}}</label>
        <kal-table
            [columns]="columns"
            [dataSource]="dataSources[planAndSections.plan.Id]"
            class="no-action">

            <tr *kalHeaderRowDef kal-header-row></tr>

            <!-- Compte -->
            <ng-container [kalColumn]="columns[0].code">
                <td *kalBodyCell="let row">
                    <kal-select [formControl]="row.get('section')">
                        <kal-option *ngFor="let section of planAndSections?.sections"
                                    [value]="section.Id">
                            <span [style.text-indent.em]="section.Niveau - 1">
                                {{section.Libelle}}
                            </span>
                        </kal-option>
                    </kal-select>
                </td>
            </ng-container>

            <!-- pourcentage -->
            <ng-container [kalColumn]="columns[1].code">
                <th *kalHeaderCell class="-textCenter">{{ columns[1].label }}</th>
                <td *kalBodyCell="let row">
                    <kal-input type="currency" icon="%" [formControl]="row.get('percentage')">
                    </kal-input>
                </td>
            </ng-container>

            <!-- montant -->
            <ng-container [kalColumn]="columns[2].code">
                <th *kalHeaderCell class="-textCenter">{{ columns[2].label }}</th>
                <td *kalBodyCell="let row">
                    <kal-input type="currency" icon="euro" [formControl]="row.get('amount')">
                    </kal-input>
                </td>
            </ng-container>

            <!-- actions -->
            <ng-container [kalColumn]="columns[3].code">
                <td *kalBodyCell="let row">

                    <kal-button kalTheme="tertiary"
                                [kalMenuTriggerFor]="actionsMenu">
                        <kal-icon>more_horiz</kal-icon>
                    </kal-button>

                    <kal-menu #actionsMenu>
                        <kal-option (selectionChange)="removeRow(planAndSections.plan, row)">
                            Supprimer
                        </kal-option>
                    </kal-menu>
                </td>
            </ng-container>

        </kal-table>

        <a class="gup-C-moreInfos gup-O-link" (click)="addRow(planAndSections.plan)">
            <kal-icon>add</kal-icon>
            <span>Ajouter une section analytique</span>
        </a>
    </div>
</div>
